export default "__VITE_ASSET__CBGZt0tO__"